"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelParamsForGrids = exports.labelCategoryToString = exports.LabelWrapper = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const gridInheritedTypes = ['datasource-fields', 'workbook-fields', 'flow-fields', 'vconn-columns', 'table-columns'];
/** @deprecated */
function LabelWrapper(props) {
    return useRenderLabelsDC3(props);
}
exports.LabelWrapper = LabelWrapper;
function useRenderLabelsDC3({ itemInfo, kind, popoverPlacement, category }) {
    var _a, _b, _c, _d, _e;
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const contentInfo = getContentInfo(itemInfo, siteUrls);
    const isTable = itemInfo.__typename === 'DatabaseTable' || itemInfo.__typename === 'VirtualConnectionTable';
    const isEmbeddedDatasource = itemInfo.__typename === 'EmbeddedDatasource';
    const labelParams = {
        catalogEnabled: true,
        content: {
            contentId: itemInfo.id,
            contentLuid: (_a = contentInfo.contentLuid) !== null && _a !== void 0 ? _a : undefined,
            contentType: contentInfo.contentType,
            contentName: (_b = itemInfo.name) !== null && _b !== void 0 ? _b : undefined,
            contentUrl: (_c = contentInfo.contentUrl) !== null && _c !== void 0 ? _c : undefined,
            subjectArea: (_d = contentInfo.subjectArea) !== null && _d !== void 0 ? _d : undefined,
            remoteType: (_e = contentInfo.remoteType) !== null && _e !== void 0 ? _e : undefined,
        },
        displayCategories: category ? buildDisplayCategories(category) : undefined,
        includeUpstream: true,
        includeParented: isTable,
        probablyOrEager: 'eager',
        testId: contentInfo.testId,
        controls: {
            kind: kind !== null && kind !== void 0 ? kind : (isEmbeddedDatasource ? 'icon' : 'chip'),
            siteUrls: siteUrls,
            popoverPlacement,
        },
        urls: siteUrls,
    };
    return (0, data_catalog_shared_1.useRenderLabels)(labelParams);
}
function getContentInfo(_a, siteUrls) {
    var { __typename } = _a, labelContentItem = tslib_1.__rest(_a, ["__typename"]);
    switch (__typename) {
        case 'PublishedDatasource': {
            const publishedDatasourceContentItem = labelContentItem;
            return {
                contentLuid: publishedDatasourceContentItem.luid,
                contentType: 'table',
                subjectArea: __typename,
                testId: 'PublishedDatasourceLabelsMasthead',
                contentUrl: siteUrls.datasourceUrl(publishedDatasourceContentItem.vizportalUrlId),
            };
        }
        case 'VirtualConnectionTable': {
            const virtualConnectionTableContentItem = labelContentItem;
            return {
                contentLuid: virtualConnectionTableContentItem.luid,
                contentType: 'table',
                subjectArea: __typename,
                testId: 'VirtualConnectionTableLabelsMasthead',
                contentUrl: siteUrls.virtualConnectionTableUrl(virtualConnectionTableContentItem.vizportalUrlId),
            };
        }
        case 'DatabaseTable':
            return {
                contentLuid: labelContentItem.luid,
                contentType: 'table',
                contentUrl: siteUrls.catalogTableUrl(labelContentItem.id),
                subjectArea: __typename,
                testId: 'TablePlacePageLabelsMasthead',
            };
        case 'Column': {
            const columnContentItem = labelContentItem;
            return {
                contentLuid: columnContentItem.luid,
                contentType: 'column',
                contentUrl: columnContentItem.table
                    ? siteUrls.catalogTableColumnUrl(columnContentItem.table.id, columnContentItem.id)
                    : null,
                subjectArea: 'Column',
                testId: 'ColumnDetailsLabelDialog',
                remoteType: columnContentItem.remoteType,
            };
        }
        case 'GroupField':
        case 'ColumnField':
        case 'DatasourceField':
        case 'CombinedField':
        case 'CalculatedField':
        case 'BinField':
        case 'HierarchyField':
        case 'CombinedSetField':
        case 'SetField':
        case 'Field':
            return {
                contentLuid: null,
                contentType: null,
                contentUrl: null,
                subjectArea: 'Field',
                testId: 'FieldDetailsLabelDialog',
            };
        case 'FlowColumnOutputField':
            return {
                contentLuid: null,
                contentType: null,
                contentUrl: null,
                subjectArea: 'FlowColumnOutputField',
                testId: 'FlowColumnFieldDetailsLabelDialog',
            };
        case 'FlowFieldOutputField':
            return {
                contentLuid: null,
                contentType: null,
                contentUrl: null,
                subjectArea: 'FlowFieldOutputField',
                testId: 'FlowFieldDetailsLabelDialog',
            };
        case 'View':
            return {
                contentLuid: null,
                contentType: null,
                contentUrl: null,
                subjectArea: __typename,
                testId: 'DataDetailsLabelsChip',
            };
        case 'EmbeddedDatasource':
            return {
                contentLuid: null,
                contentType: null,
                contentUrl: null,
                subjectArea: __typename,
                testId: 'DataDetailsLabelsIcon',
            };
        case 'DataCloud':
        case 'CloudFile':
        case 'File':
        case 'WebDataConnector':
        case 'DatabaseServer':
            return {
                contentLuid: labelContentItem.luid,
                contentType: 'database',
                contentUrl: siteUrls.catalogDatabaseUrl(labelContentItem.id),
                subjectArea: __typename,
                testId: 'DatabasePlacePageLabelsMasthead',
            };
        case 'CustomSQLTable':
            return {
                contentLuid: null,
                contentType: null,
                contentUrl: null,
                subjectArea: null,
                testId: __typename,
            };
        default:
            (0, catalog_core_1.assertUnreachable)(__typename);
            throw new Error('Unreachable');
    }
}
function labelCategoryToString(category) {
    switch (category) {
        case 'CERTIFICATION':
            return 'certification';
        case 'WARNING':
            return 'warning';
        case 'SENSITIVITY':
            return 'sensitivity';
        case 'CUSTOM':
            return 'custom';
        default:
            (0, catalog_core_1.assertUnreachable)(category);
            return 'warning';
    }
}
exports.labelCategoryToString = labelCategoryToString;
function buildDisplayCategories(category) {
    return {
        warning: category === 'warning' ? true : undefined,
        certification: category === 'certification' ? true : undefined,
        sensitivity: category === 'sensitivity' ? true : undefined,
        custom: !((0, data_catalog_shared_1.isBuiltInLabelCategory)(category)) ? true : undefined,
    };
}
function buildProbablyOrEager(category, value, highestSeverity, count) {
    if (count <= 0) {
        return undefined;
    }
    switch (category) {
        case 'CERTIFICATION':
            return {
                certified: true,
            };
        case 'WARNING':
            return {
                warning: {
                    value,
                    severe: highestSeverity,
                    count,
                },
            };
        case 'SENSITIVITY':
            return {
                sensitivity: { value, count, severe: highestSeverity },
            };
        case 'CUSTOM':
            return {
                custom: [{ category, value, count }],
            };
        default:
            (0, catalog_core_1.assertUnreachable)(category);
            return undefined;
    }
}
function getLabelParamsForGrids({ category, labels, urls, source, content }) {
    const categoryLabels = [];
    if (category === 'CUSTOM') { // include both sensitive and custom labels
        const sensitiveLabels = labels.filter((label) => (label.category === 'SENSITIVITY' && label.isActive));
        const sensitiveLabelValue = sensitiveLabels.length > 0 ? sensitiveLabels[0].value : 'sensitivity';
        const customLabels = labels.filter((label) => (!(0, data_catalog_shared_1.isBuiltInLabelCategory)(label.category) && label.isActive));
        const customGrouped = (0, vizportalclient_common_components_1.groupByToMultimap)({
            data: customLabels,
            keyTransform: (original) => (original.category),
            valTransform: (v) => v,
            keyBy: (category) => category,
        });
        const uniqueCustomCategories = [...new Set(customLabels.map(a => a.category))];
        const customProbably = [];
        uniqueCustomCategories.forEach((category) => {
            const categoryLabels = customGrouped.get(category);
            if (categoryLabels) {
                customProbably.push({ category, value: categoryLabels[0].value, count: categoryLabels.length });
            }
        });
        const highestSensitivitySeverity = sensitiveLabels.some((label) => label.isActive && label.isElevated);
        return {
            catalogEnabled: true,
            content: content,
            probablyOrEager: {
                sensitivity: sensitiveLabels.length > 0
                    ? { value: sensitiveLabelValue, count: sensitiveLabels.length, severe: highestSensitivitySeverity }
                    : undefined,
                custom: customLabels.length > 0 ? customProbably : undefined,
            },
            includeParented: source === 'tables',
            includeUpstream: gridInheritedTypes.includes(source),
            testId: source + '-' + category.toLowerCase() + '-column',
            controls: {
                kind: 'chip',
                siteUrls: urls,
            },
        };
    }
    else {
        categoryLabels.push(...labels.filter((label) => label.category === category));
        const isActiveList = categoryLabels.filter((label) => label.isActive);
        const count = isActiveList.length;
        const highestSeverity = categoryLabels.some((label) => label.isActive && label.isElevated);
        const labelValue = count > 0 ? isActiveList[0].value : category;
        return {
            catalogEnabled: true,
            content: content,
            probablyOrEager: buildProbablyOrEager(category, labelValue, highestSeverity, count),
            includeParented: source === 'tables',
            includeUpstream: gridInheritedTypes.includes(source),
            testId: source + '-' + category.toLowerCase() + '-column',
            controls: {
                kind: (category === 'SENSITIVITY') ? 'chip' : 'icon',
                siteUrls: urls,
            },
        };
    }
}
exports.getLabelParamsForGrids = getLabelParamsForGrids;
//# sourceMappingURL=LabelsHookHelper.js.map